import React, { useState, useEffect } from "react";

function VoterLogin({ submitVoterEmail }) {    
    const [ voterMail, setVoterMail ] = useState("")
    const [ msg, setMsg ] = useState()

    const handleChange = event => {
        setVoterMail(event.target.value)
    }

    const handleSubmit = event => {
        event.preventDefault()

        fetch(`/api/auth-ok?voter=${voterMail}`)
            .then(r => {
                if (r.ok) {
                    submitVoterEmail(voterMail)
                } else {
                    console.error("unauthorized")
                    setMsg("Geht nicht")
                }
            })
    }

    useEffect(() => {
        let params = new URLSearchParams(window.location.search)
        setVoterMail(params.get("voter") || "")
    }, [])

    return (
        <form onSubmit={handleSubmit}>
            <hgroup>
                <h1>Login</h1>
                <h2>Zur Wahl zugelassene Email angeben</h2>
            </hgroup>
            <input type="email" value={voterMail} onChange={handleChange} />
            <button type="submit">Anmelden</button>
            { msg && (
                <dialog open>
                    <article>
                        <header>
                            Email-Adresse nicht stimmberechtigt
                        </header>
                        <p>
                            Die angegebene Email-Adresse ist nicht stimmberechtigt. Bitte melden Sie sich bei der Wahlleitung.
                        </p>
                        <footer>
                            <a href="/" role="button" onClick={() => setMsg(undefined)}>Ok</a>
                        </footer>
                    </article>
                </dialog>
            )}
        </form>
    )
}

export default VoterLogin;